export const IRPS = 'IRPS';
export const IRPS_START = 'IRPS_START';
export const IRPS_SUCCESS = 'IRPS_SUCCESS';
export const IRPS_ERROR = 'IRPS_ERROR';

export const IRP_MODALIDADES = 'IRP_MODALIDADES';
export const IRP_MODALIDADES_START = 'IRP_MODALIDADES_START';
export const IRP_MODALIDADES_SUCCESS = 'IRP_MODALIDADES_SUCCESS';
export const IRP_MODALIDADES_ERROR = 'IRP_MODALIDADES_ERROR';

export const IRP = 'IRP';
export const IRP_START = 'IRP_START';
export const IRP_SUCCESS = 'IRP_SUCCESS';
export const IRP_ERROR = 'IRP_ERROR';

export const IRP_ITENS = 'IRP_ITENS';
export const IRP_ITENS_START = 'IRP_ITENS_START';
export const IRP_ITENS_SUCCESS = 'IRP_ITENS_SUCCESS';
export const IRP_ITENS_ERROR = 'IRP_ITENS_ERROR';

export const IRP_ARQUIVOS = 'IRP_ARQUIVOS';
export const IRP_ARQUIVOS_START = 'IRP_ARQUIVOS_START';
export const IRP_ARQUIVOS_SUCCESS = 'IRP_ARQUIVOS_SUCCESS';
export const IRP_ARQUIVOS_ERROR = 'IRP_ARQUIVOS_ERROR';

export const RESET_CONSULTA_IRPS = 'RESET_CONSULTA_IRPS';
